<div class="container-margin">
  <h2>{{ translationService.getIntegrationsText() }}</h2>
  <div class="actions margin-top-10">
    <button
      type="button"
      mat-raised-button
      extended
      color="accent"
      class="action-button"
      (click)="create()"
    >
      <mat-icon>add</mat-icon>
      {{ translationService.getCreateText() }}
    </button>
  </div>
  <div class="margin-top-20">
    <app-integrations-list
      [refreshListSubject]="refreshListSubject"
    ></app-integrations-list>
  </div>
</div>
